import {Component, Input} from '@angular/core';
import {Producto} from '../../../_models/producto';

@Component({
  selector: 'app-producto-montos-tasas',
  templateUrl: './producto-montos-tasas.component.html',
  styleUrl: './producto-montos-tasas.component.css'
})
export class ProductoMontosTasasComponent {
  @Input() producto: Producto;
  @Input() isDetail: boolean = false;
}
